module.exports = __webpack_public_path__ + "static/img/Danny-Buderus.59529e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Danny-Buderus.jpg
// module id = SVlv
// module chunks = 0